import { SurveyService } from "@Services/Survey.Service"
import { useState } from "react"

export const useSurveyHooks = () => {
    const [fetchingSurvey, setFetchingSurvey] = useState(false)
    const [surveysList, setSurveysList] = useState([])

    const fetchSurveys = ({ setCurrentQuestionIndex, axisId, fromPrev }) => {
        setFetchingSurvey(true)
        SurveyService.getByAxis(axisId)
            .then((response) => {
                const data = response?.data?.data
                if (data) {
                    const removeParentItem = data?.filter((item) => item?.hasChild === 0) ?? []
                    setSurveysList(removeParentItem)
                    if (fromPrev) {
                        setCurrentQuestionIndex(removeParentItem?.length - 1)
                    } else {
                        setCurrentQuestionIndex(0)
                    }
                }
                setFetchingSurvey(false)
            })
            .catch((e) => {
                ShowToast({ type: "error", message: message.serverError })
                setFetchingSurvey(false)
            })
    }

    return {
        fetchingSurvey,
        surveysList,
        fetchSurveys
    }
}
